import { PartnerAppRegistrationService } from "@fxp/fxpservices";
import { DMApp } from "./application";
// Register the route with FXP
PartnerAppRegistrationService.registerPartnerApp("DMApp", DMApp);

